export default {
  BASE_URL: '',
  api: [
    {
      name: 'importOrderList',
      desc: '获取导入订单推送列表',
      method: 'GET',
      path: '/tm/order/importOrderList'
    },
    {
      name: 'pushToJinDie',
      desc: '订单推送至金蝶服务器',
      method: 'POST',
      path: '/tm/order/pushToJinDie'
    },
    {
      name: 'getOrderPushLog',
      desc: '获取订单操作历史',
      method: 'GET',
      path: '/push/jindie/log/orderList'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/push/pushHistory.js